import { RelocationItemInput } from "@/gql/graphql";

export type ImportColumnId = keyof RelocationItemInput;
export const defaultColOrder: ImportColumnId[] = [
  "quantity",
  "line",
  "vehicle_code",
  "departure_office_code",
  "delivery_office_code",
  "available_from",
  "available_to",
  "hire_units_allowed",
  "minimum_hire_units",
  "extra_hire_units_allowed",
  "distance_allowed",
  "fuel_amount",
  "fuel_note",
  "ferry_note",
  "inclusion_note",
  "hire_unit_rate",
  "extra_hire_unit_supplier_net_rate",
  "preparation_charge_amount",
  "preparation_charge_note",
];

export const defaultHiddenCols: ImportColumnId[] = [
  "quantity",
  "minimum_hire_units",
  "distance_allowed",
  "fuel_note",
  "ferry_note",
  "inclusion_note",
  "hire_unit_rate",
  "extra_hire_unit_supplier_net_rate",
  "preparation_charge_amount",
  "preparation_charge_note",
];
